<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ action }}</div>
    <div slot="body">
      <detail
        v-if="!params.isChangeConfig"
        :data="detailsData"
        :detailsData="detailsData"
        :extraInfo="extraInfo"
        hiddenBaseInfo />
      <div v-else>
        <div class="detail-title mb-2">{{ $t('common_376') }}</div>
        <server-config-list :variables="changeConfigVariables" :configs="params.serverConfList" />
      </div>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="cancelDialog">{{ $t('dialog.ok') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import serverConfMixin from '@System/views/workflow/mixins/serverConf'
import PriceMixin from '@System/views/workflow/mixins/price'
import ServerConfigList from '@System/views/workflow/components/ServerConfig'

export default {
  name: 'WorkflowResourceViewDialog',
  components: {
    ServerConfigList,
  },
  mixins: [DialogMixin, WindowsMixin, serverConfMixin, PriceMixin],
  data () {
    return {
      loaded: false,
      action: this.$t('common.view'),
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      data: this.params.workflowData,
      variables: this.params.variables,
      detailsData: { ...this.params.serverData, variables: this.params.variables },
      extraInfo: [],
    }
  },
  computed: {
    changeConfigVariables () {
      const list = this.params.serverConfList
      if (Array.isArray(list) && list.length) {
        return {
          ...(this.params.variables || {}),
          serverConf: JSON.stringify(list),
          change_type: this.params.variables?.change_type || 'change-config',
        }
      }
      return this.params.variables || this.variables || {}
    },
  },
  async created () {
    if (this.params.isChangeConfig) return
    await this.getApplyMachineData()
    await this.initResourceViewInfo()
    await this.initPriceInfo()
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
::v-deep .detail-item {
  position: relative;
}
.detail-title {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}
</style>
